import { ItemImageModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class RemoteDepositImage extends DomainEntity<ItemImageModelDto> {
    public createDefault(): this {
        return new RemoteDepositImage({}) as this;
    }

    public get frontImage() {
        return this.dto.frontImage;
    }

    public get backImage() {
        return this.dto.backImage;
    }

    public get itemReference() {
        return this.dto.itemReference;
    }
}
